import {GetTypes} from "../../../../helpers/enum-helpers";

export enum LegalForm {
  AG = 31,
  AGCoKG = 25,
  AGCoOHG = 26,
  AndereGenossenschaft = 49,
  AtypischeStilleGesellschaft = 20,
  AuslaendischeKoerperschaft = 91,
  AuslaendischePersonengesellschaft = 92,
  BergrechtlicheGewerkschaft = 34,
  EG = 30,
  EV = 52,
  SE = 36,
  EWIV = 28,
  Gebietskoerperschaft = 81,
  GGmbH = 38,
  GbR = 27,
  GmbH = 35,
  GmbHCoKG = 23,
  GmbHCoOHG = 24,
  Kolonialgesellschaft = 33,
  KG = 22,
  KGaA = 32,
  Kreditgenossenschaft = 41,
  LandwirtschaftGenossenschaft = 43,
  NichtrechtsfaehigerVerein = 61,
  OHG = 21,
  OeReligionsgesellschaft = 82,
  OeVersorgungsbetrieb = 74,
  Sparkasse = 72,
  Beteiligungsperson = 16,
  Realgemeinde = 44,
  SCEGenossenschaft = 45,
  SonstigeAuslRechtsform = 99,
  SonstigeJPPrivat = 59,
  SonstigeJPOeffentlich = 83,
  SonstigeKapitalgesellschaft = 39,
  SonstigeKreditanstaltOe = 73,
  SonstigePersonengesellschaft = 29,
  SonstigerBetriebOe = 79,
  Staatsbank = 71,
  StiftungCoKG = 40,
  UG = 37,
  VVaG = 51,
  Zentralkasse = 42,
}

// Descriptions map
export const LegalFormDescription: { [key: number]: string } = {
  [LegalForm.AG]: "Aktiengesellschaft",
  [LegalForm.AGCoKG]: "Aktiengesellschaft u. Co. KG",
  [LegalForm.AGCoOHG]: "Aktiengesellschaft u. Co. OHG",
  [LegalForm.AndereGenossenschaft]: "Andere Erwerbs- oder Wirtschaftsgenossenschaft",
  [LegalForm.AtypischeStilleGesellschaft]: "Atypische stille Gesellschaft",
  [LegalForm.AuslaendischeKoerperschaft]: "Ausländische Körperschaft",
  [LegalForm.AuslaendischePersonengesellschaft]: "Ausländische Personengesellschaft",
  [LegalForm.BergrechtlicheGewerkschaft]: "Bergrechtliche Gewerkschaft",
  [LegalForm.EG]: "Eingetragene Genossenschaft (eG)",
  [LegalForm.EV]: "Eingetragener Verein",
  [LegalForm.SE]: "Europäische Aktiengesellschaft",
  [LegalForm.EWIV]: "Europäische wirtschaftliche Interessenvereinigung",
  [LegalForm.Gebietskoerperschaft]: "Gebietskörperschaft",
  [LegalForm.GGmbH]: "Gemeinnützige Gesellschaft mit beschränkter Haftung (gGmbH)",
  [LegalForm.GbR]: "Gesellschaft des bürgerlichen Rechts",
  [LegalForm.GmbH]: "Gesellschaft mit beschränkter Haftung",
  [LegalForm.GmbHCoKG]: "GmbH u. Co. KG",
  [LegalForm.GmbHCoOHG]: "GmbH u. Co. OHG",
  [LegalForm.Kolonialgesellschaft]: "Kolonialgesellschaft",
  [LegalForm.KG]: "Kommanditgesellschaft",
  [LegalForm.KGaA]: "Kommanditgesellschaft auf Aktien",
  [LegalForm.Kreditgenossenschaft]: "Kreditgenossenschaft, die Kredite ausschließlich an ihre Mitglieder gewährt",
  [LegalForm.LandwirtschaftGenossenschaft]: "Landwirtschaftl. Nutzungs- oder Verwaltungsgenossenschaft",
  [LegalForm.NichtrechtsfaehigerVerein]: "Nichtrechtsfähiger Verein, Anstalt, Stiftung oder anderes Zweckvermögen",
  [LegalForm.OHG]: "Offene Handelsgesellschaft",
  [LegalForm.OeReligionsgesellschaft]: "Öffentl.-rechtl. Religionsgesellschaft",
  [LegalForm.OeVersorgungsbetrieb]: "Öffentl.-rechtl. Versorgungs-, Verkehrs- oder Hafenbetrieb",
  [LegalForm.Sparkasse]: "Öffentliche oder unter Staatsaufsicht stehende Sparkasse",
  [LegalForm.Beteiligungsperson]: "Person mit Beteiligungen an gewerbl. Personengesellschaften",
  [LegalForm.Realgemeinde]: "Realgemeinde",
  [LegalForm.SCEGenossenschaft]: "SCE Europäische Genossenschaft",
  [LegalForm.SonstigeAuslRechtsform]: "Sonstige ausländische Rechtsform",
  [LegalForm.SonstigeJPPrivat]: "Sonstige juristische Person des privaten Rechts",
  [LegalForm.SonstigeJPOeffentlich]: "Sonstige juristische Personen des öffentlichen Rechts",
  [LegalForm.SonstigeKapitalgesellschaft]: "Sonstige Kapitalgesellschaft",
  [LegalForm.SonstigeKreditanstaltOe]: "Sonstige Kreditanstalt des öffentlichen Rechts",
  [LegalForm.SonstigePersonengesellschaft]: "Sonstige Personengesellschaft (z.B. Grundstücksgemeinschaft o.Ä.)",
  [LegalForm.SonstigerBetriebOe]: "Sonstiger Betrieb gewerblicher Art von jur. Personen des öffentlichen Rechts",
  [LegalForm.Staatsbank]: "Staatsbank",
  [LegalForm.StiftungCoKG]: "Stiftung & Co. KG",
  [LegalForm.UG]: "Unternehmergesellschaft (haftungsbeschränkt)",
  [LegalForm.VVaG]: "Versicherungsverein auf Gegenseitigkeit",
  [LegalForm.Zentralkasse]: "Zentralkasse, die Kredite ausschließlich an ihre Mitglieder gewährt und sich auf genossenschaftl. Aufgaben beschränkt",
};

export const LegalFormList: LegalForm[] = GetTypes(LegalForm)
  .map(x => parseInt(x))
  .sort((a, b) => LegalFormDescription[a].localeCompare(LegalFormDescription[b]));
